import React, { Suspense } from "react";
import { useCmsblock } from "../../Pregrine/CmsBlock/useCmsblock";
import DOMPurify from "dompurify";
import Shimmer from "../Shimmer";

const CmsBlock = (props) => {
  const { IDENTIFIER } = props;

  const talonProps = useCmsblock({ identifier: IDENTIFIER });
  const { CmsBlockData, loading } = talonProps;

  if (loading) {
    return <Shimmer width="100%" height="25rem" />;
  }

  if (!CmsBlockData) {
    return null;
  }

  const sanitizedHtml = DOMPurify.sanitize(CmsBlockData.content);
  const cleanedHtml = sanitizedHtml.replace(/&lt;/g, "<").replace(/&gt;/g, ">");

  return (
    <>
      <Suspense fallback={<Shimmer width="100%" height="25rem" />}>
        <div dangerouslySetInnerHTML={{ __html: cleanedHtml }} />
      </Suspense>
    </>
  );
};

export default CmsBlock;
